import { ABRIR_EJERCICIO,CERRAR_EJERCICIO } from "../constants/actions-types";

const ejercicioDefault = {
	visible:false,
	titulo:"",
	texto:"",
};

function ejercicioReducer(state = ejercicioDefault, action) {
	if (action.type === ABRIR_EJERCICIO) {
		let newEjercicio = {...state};
		newEjercicio.titulo = action.ejercicio.titulo; 
		newEjercicio.texto = action.ejercicio.texto;
		newEjercicio.visible = true;
		return newEjercicio;
	}else if (action.type === CERRAR_EJERCICIO) {
		let newEjercicio = {...state};
		newEjercicio.visible = false;
		return newEjercicio;
	}
	return state;
}

export default ejercicioReducer;